var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotsIconVertical = function SvgDotsIconVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dots-icon-vertical_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3.176c.975 0 1.765-.71 1.765-1.588C7.765.711 6.975 0 6 0c-.975 0-1.765.711-1.765 1.588 0 .877.79 1.588 1.765 1.588ZM6 7.765c.975 0 1.765-.711 1.765-1.588 0-.878-.79-1.589-1.765-1.589-.975 0-1.765.711-1.765 1.589 0 .877.79 1.588 1.765 1.588ZM6 12c.975 0 1.765-.71 1.765-1.588 0-.877-.79-1.588-1.765-1.588-.975 0-1.765.71-1.765 1.588C4.235 11.289 5.025 12 6 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dots-icon-vertical_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgDotsIconVertical;